/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import valenciano from './valenciano';
import deutsch from './deutsch';
import english from './english';
import français from './français';
import italiano from './italiano';
import pусский from './pусский';
import portugues from './portugues';
import holandes from './holandes';
import polski from './polski';


const messages = {
    Español: castellano,
    Valencià: valenciano,
    Deutsch: deutsch,
    English: english,
    Français: français,
    Italiano: italiano,
    Português: portugues,
    Nederlands: holandes,
    Pусский: pусский,
    Polski: polski
}



export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js